enum exception {
    'complete_request' = 'Operation completed successfully.',
    'could_not_complete_request' = 'Could not complete your request.\r\nPlease try again later.',
}

export default exception;
